export default {"src":"/_next/static/media/LinkedInIcon.e5f8308b.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};